module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("T")]), _vm._v("hanks to John Libbey for giving the go-ahead for this volume hot on the heels of its predecessor – "), _c('i', [_vm._v("Making a Splash: Mermaids (and Mermen) in 20"), _c('sup', [_vm._v("th")]), _vm._v(" and 21"), _c('sup', [_vm._v("st")]), _vm._v(" Century Audiovisual Media")]), _vm._v(" – published in April 2017. Thanks also to Adam Grydehøj for organising the Mermaids, Maritime Folklore and Modernity conference in Copenhagen in October 2017, which connected me to some of the authors who have contributed to this volume.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I am grateful to the State Library of New South Wales and the University of Technology Sydney library for their efficiency and to the staff of Manly and Waverley public library local history sections for their positive and proactive support. Thanks to Alison Rahn for various assistances, to Hannah Murphy for diligent proofing, to Lucy Guenot for the front cover design and to Isis Blue Fire for permission to reproduce her mermaid cosplay image on the cover.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My parents – Ruth and Roy – were, as ever, intrigued by and enthusiastic about my latest publication project. I trust they find it of interest.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("Note")]), _vm._v(": Every effort has been made to identify the original sources and obtain necessary permissions to reproduce photographic material used in this volume. Any inquiries on matters related to this should be addressed to the author.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65174020","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Acknowledgements.vue
// module id = 75
// module chunks = 0